module.exports = __webpack_public_path__ + "b4a5cd969162693be3e92394627a244d.png";